import ContentTemplate from '../../components/ContentTemplate';
import NewConstructionLayout from '../../components/NewConstructionLayout';
import {
    buildPrimaryPostPage,
    PostPageContentProps,
} from '../../util/buildPrimaryPostPage';

// Export ContentProps for use in preview
export type ContentProps = PostPageContentProps;

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'CONSTRUCTION',
        basePath: '/new-construction-advertising',
        LayoutComponent: NewConstructionLayout,
        hasStickyNav: true,
        ContentComponent: ContentTemplate,
        contentType: 'B2B',
        menuPropName: 'submenu',
        useBasePathForId: false,
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
